// Size chart unit toggle
document.addEventListener('click', function(e) {
  if (e.target.classList.contains('block-swatch__item') && e.target.closest('.size-chart-container')) {
    var container = e.target.closest('.size-chart-container');
    var unit = e.target.getAttribute('data-unit');
    var input = e.target.previousElementSibling;

    container.querySelectorAll('.size-unit-radio').forEach(function(radio) {
      radio.checked = false;
    });
    input.checked = true;

    if (unit === 'cm') {
      container.querySelector('.table-cm').style.display = 'table';
      container.querySelector('.table-inch').style.display = 'none';
    } else {
      container.querySelector('.table-cm').style.display = 'none';
      container.querySelector('.table-inch').style.display = 'table';
    }
  }
});
